// Pengelompokan rincian Rotasi Klinik "Per Instalasi" per Program Studi. Angka per kelompok
// (per_prodi) dihitung SERVER dgn cara yg sama dgn baris instalasi (PPDS unik per jenis,
// Total = Stase + Jaga) -- di sini hanya menyusun & mengurutkan.

export const URUT_PRODI = [
    { value: "nama", label: "Nama Prodi" },
    { value: "jumlah", label: "Jumlah terbanyak" },
];

// Kelompok hanya bila instalasi itu memuat lebih dari satu Program Studi.
export const perluKelompok = (row) => (row?.per_prodi?.length || 0) > 1;

export function kelompokkanRincian(row, urut = "nama") {
    const rincian = new Map();
    (row?.rincian || []).forEach((d) => {
        const k = d.prodi_label ?? d.prodi_nama;
        if (!rincian.has(k)) rincian.set(k, []);
        rincian.get(k).push(d);
    });
    const banding = (a, b) => a.prodi_label.localeCompare(b.prodi_label, "id");
    return (row?.per_prodi || [])
        .map((p) => ({
            ...p,
            rincian: [...(rincian.get(p.prodi_label) || [])].sort((a, b) => a.nama.localeCompare(b.nama, "id")),
        }))
        .sort(urut === "jumlah" ? (a, b) => b.total - a.total || banding(a, b) : banding);
}
